// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.AgentLicenseType

export enum AgentLicenseType {
  ASSOCIATE_REAL_ESTATE_BROKER = 'ASSOCIATE_REAL_ESTATE_BROKER',
  REAL_ESTATE_BROKER = 'REAL_ESTATE_BROKER',
  REAL_ESTATE_SALES_PERSON = 'REAL_ESTATE_SALES_PERSON',
}

export const AgentLicenseType_values = [
  AgentLicenseType.ASSOCIATE_REAL_ESTATE_BROKER,
  AgentLicenseType.REAL_ESTATE_BROKER,
  AgentLicenseType.REAL_ESTATE_SALES_PERSON,
] as const;
